import { Box, Button, Grid, TextField, InputLabel, Typography, useTheme, Select, MenuItem } from '@mui/material'
import { useInsumo } from '../../../../shared/context/insumoContext'
import { useUtiles } from '../../../../shared/context/utilesContext'
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material'
import { useForm, Controller } from 'react-hook-form'
import moment from 'moment'


const descriptionesEntrada = [
    "Compra de materiales",
    "Devolución de materiales",
    "Ajuste de inventario",
    "Transferencia entre almacenes",
    "Donación recibida",
    "Reposición de stock",
    "Material recuperado",
    "Corrección de error",
    "Otros"
]
const descriptionesSalida = [
    "Ajuste de inventario",
    "Venta de materiales",
    "Devolución de materiales",
    "Transferencia entre almacenes",
    "Donación entregada",
    "Material perdido",
    "Corrección de error",
    "Otros"
]

export default function AumentarDisminuirStockComponent() {
    const { increaseStock, decreaseStock, loadingIncreaseStock, loadingDecreaseStock, typeStock, insumo } = useInsumo()
    const { locationString } = useUtiles()
    const theme = useTheme()
    const { handleSubmit, control, formState: { errors, isValid }, setValue } = useForm({
        defaultValues: {
            quantity: 0,
            date: moment().format('YYYY-MM-DD'),
            description: typeStock === 'entrada' ? descriptionesEntrada[0] : descriptionesSalida[0]
        },
        mode: 'onChange'
    })

    

    const onSubmit = async (data) => {
        if (typeStock === 'entrada') {
             const success = await increaseStock(insumo.id, data.quantity, data.date)
             if (success) {
                setValue('quantity', 0)
                setValue('date', moment().format('YYYY-MM-DD'))
                setValue('description', typeStock === 'entrada' ? descriptionesEntrada[0] : descriptionesSalida[0])
             }
        } else {
            const success = await decreaseStock(insumo.id, data.quantity, data.date)
            if (success) {
                setValue('quantity', 0)
                setValue('date', moment().format('YYYY-MM-DD'))
                setValue('description', typeStock === 'entrada' ? descriptionesEntrada[0] : descriptionesSalida[0])
            }
        }
    }

    return (
        <Box sx={{ p: 2 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }}>
                        <Typography variant='h6'>{insumo.name} ({insumo.amount} {insumo.unit}s)</Typography>
                        <Typography variant='caption'>{insumo.code}</Typography>
                        <Typography variant='body2' sx={{ whiteSpace: 'pre-wrap', fontWeight: 'bold' }}>{insumo.description}</Typography>
                        <Typography variant='body2'>{locationString(insumo.location)}</Typography>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Cantidad a {typeStock === 'entrada' ? 'Aumentar' : 'Disminuir'}</InputLabel>
                        <Controller
                            control={control}
                            name='quantity'
                            rules={{
                                required: 'La cantidad es requerida',
                                min: {
                                    value: 1,
                                    message: 'La cantidad debe ser mayor a 0'
                                },
                                validate: (value) => {
                                    if (value <= 0) {
                                        return 'La cantidad no puede ser menor o igual a 0'
                                    }
                                    return true
                                }
                            }}
                            render={({ field }) => (
                                <TextField
                                    type='number'
                                    fullWidth
                                    value={field.value}
                                    onChange={(e) => field.onChange(e)}
                                    error={!!errors.quantity}
                                    helperText={errors.quantity?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Fecha</InputLabel>
                        <Controller
                            control={control}
                            name='date'
                            rules={{
                                required: 'La fecha es requerida'
                            }}
                            render={({ field }) => (
                                <TextField
                                    type='date'
                                    fullWidth
                                    value={field.value}
                                    onChange={(e) => field.onChange(e)}
                                    error={!!errors.date}
                                    helperText={errors.date?.message}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12 }}>
                        <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Tipo de Movimiento</InputLabel>
                        <Controller
                            control={control}
                            name='description'
                            render={({ field }) => (
                                <Select
                                    fullWidth
                                    value={field.value}
                                    onChange={(e) => field.onChange(e)}
                                    error={!!errors.type}
                                    helperText={errors.type?.message}
                                >
                                    {typeStock === 'entrada' ? descriptionesEntrada.map((description) => (
                                        <MenuItem key={description} value={description}>{description}</MenuItem>
                                    )) : descriptionesSalida.map((description) => (
                                        <MenuItem key={description} value={description}>{description}</MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <Button 
                            type="submit"
                            disabled={loadingIncreaseStock || loadingDecreaseStock || !isValid} 
                            startIcon={typeStock === 'entrada' ? <AddIcon /> : <RemoveIcon />} 
                            variant='contained' 
                            color='primary'
                        >
                            {typeStock === 'entrada' ? 'Aumentar' : 'Disminuir'} Stock
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}